import type { PipeTransform } from '@angular/core';
import { inject, Pipe } from '@angular/core';
import {
    getCurrencyDefaultValue,
    getNumberFormatLocale,
    getNumberFormatWithCurrency,
} from 'libs/ng-common-lib/src/utilities/numberAndCurrencyUtility';
import { WholesaleCurrencyNumberConfigToken } from '../provider/currency.provider';

@Pipe({
    name: 'wholesaleCurrency',
    standalone: true,
})
export class WholesaleCurrencyPipe implements PipeTransform {
    protected readonly currencyNumberConfig = inject(WholesaleCurrencyNumberConfigToken);

    transform(value: number | string | undefined | null, lang = 'de', digits = 0, numberSuffix?: string): string {
        if (!value || value === 0 || typeof value !== 'number') {
            return value?.toString() ?? '';
        }

        if (!this.currencyNumberConfig) {
            throw new Error('Currency Number Config not provided');
        }

        if (numberSuffix && digits > 0) {
            throw new Error('NumberSuffix and Digits cannot be passed at the same time.');
        }

        const numberFormatLocale = getNumberFormatLocale(lang, this.currencyNumberConfig);
        const numberFormat = getNumberFormatWithCurrency(
            numberFormatLocale,
            digits,
            this.currencyNumberConfig.currency,
        );

        return getCurrencyDefaultValue(
            numberFormat.format(value).replace(`${this.currencyNumberConfig.currency}`, '').trim(),
            lang,
            this.currencyNumberConfig,
            digits,
            numberSuffix,
        );
    }
}
